<div class="myre-form__date-picker">
  <div
    class="myre-form__date-picker__title"
    [class.focus]="focus"
    [attr.readonly]="readonly"
    [class.error]="error"
    [class.warning]="warning"
  >
    <input
      #input
      matInput
      class="myre-form__field"
      [matDatepicker]="picker"
      [id]="id"
      [ngModel]="value"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [placeholder]="placeholder | translate"
      [attr.tabindex]="disabled ? -1 : 0"
      [min]="min"
      [max]="max"
      [matDatepickerFilter]="dateFilter"
      [ngClass]="{ error: error, warning: warning }"
      (ngModelChange)="onChange($event)"
      (blur)="onBlur($event, icon)"
      (focus)="onFocus()"
    />
    <mat-datepicker
      #picker
      [startAt]="value || startAt"
      startView="multi-year"
      panelClass="month-picker"
      (yearSelected)="yearSelected($event)"
      (monthSelected)="monthSelected($event)"
      (opened)="onFocus()"
      (closed)="onBlur()"
      [disabled]="disabled || readonly"
    />
    <i
      #icon
      [ngClass]="triggerIcon"
      (click)="onIconClick(picker)"
      [attr.tabindex]="-1"
    ></i>
  </div>
</div>
